export function sideBarWrapper() {
    var sidebar = document.getElementById("js-sidebar");
    var sideBarCloseButton = document.getElementById("close-sidebar");
    var sideBarOpenButton = document.getElementById("js-sidebar-open");

    sideBarOpenButton.addEventListener("click", openSideBar);
    sideBarCloseButton.addEventListener("click", closeSideBar);
    
    function closeSideBar() {
        sidebar.classList.remove("open-sidebar");
    }

    function openSideBar() {
        sidebar.classList.add("open-sidebar");
    }
}